import { Badge } from '../../ui';
import { statusMeta } from '../shared';
import type { BatchStatus } from '../../../types/clustering';

interface BatchStatusBadgeProps {
  status: BatchStatus;
  size?: 'sm' | 'md';
}

export function BatchStatusBadge({ status, size = 'sm' }: BatchStatusBadgeProps) {
  const meta = statusMeta(status);
  return (
    <Badge variant={meta.variant} size={size}>
      {meta.label}
    </Badge>
  );
}
